// Function Studio fires these when a promotion block's state changes. The dispatch target
// isn't documented, so listen on both window and document (update() is idempotent).
const GWP_FS_EVENTS = ['fs-block-activated', 'fs-block-deactivated'];

if (!customElements.get('gwp-block')) {
  customElements.define(
    'gwp-block',
    class GwpBlock extends HTMLElement {
      constructor() {
        super();
        this.blockId = this.dataset.blockId;
        this.update = this.update.bind(this);
        this.onTriggerClick = this.onTriggerClick.bind(this);
      }

      connectedCallback() {
        this.querySelectorAll('[data-gwp-trigger]').forEach((trigger) => {
          trigger.addEventListener('click', this.onTriggerClick);
        });

        GWP_FS_EVENTS.forEach((eventName) => {
          window.addEventListener(eventName, this.update);
          document.addEventListener(eventName, this.update);
        });

        // Re-check after theme cart changes in case Function Studio doesn't fire an event for them
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.update);

        this.update();
      }

      disconnectedCallback() {
        GWP_FS_EVENTS.forEach((eventName) => {
          window.removeEventListener(eventName, this.update);
          document.removeEventListener(eventName, this.update);
        });

        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
      }

      update() {
        // Always show in the theme editor so the block can be selected and styled
        const isActive =
          Boolean(window.Shopify?.designMode) ||
          Boolean(window.FSPromotions?.isBlockActive?.(this.blockId));

        this.classList.toggle('is-active', isActive);
      }

      onTriggerClick() {
        window.FSPromotions?.trigger?.(this.blockId);
      }
    }
  );
}
